const RESET_PASSWORD = 'RESET_PASSWORD';
const RESET_USER_DETAILS = 'RESET_USER_DETAILS';
const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
const API_FETCH_USER_SUCCESS = 'API_FETCH_USER_SUCCESS';
const API_FETCH_USER = 'API_FETCH_USER';
const API_FETCH_MENU_SUCCESS = 'API_FETCH_MENU_SUCCESS';
const API_FETCH_MENU = 'API_FETCH_MENU';
const API_FETCH_MENU_ITEM = 'API_FETCH_MENU_ITEM';
const API_FETCH_MENU_iTEM_SUCCESS = 'API_FETCH_MENU_iTEM_SUCCESS';
const API_FETCH_MENU_iTEM_ERROR = 'API_FETCH_MENU_iTEM_ERROR';
const UPDATE_ITEM_MENU = 'UPDATE_ITEM_MENU';
const UPDATE_ITEM_MENU_SUCCESS = 'UPDATE_ITEM_MENU_SUCCESS';
const UPDATE_ITEM_STATUS_MENU = 'UPDATE_ITEM_STATUS_MENU';
const EDIT_MENU_ITEM = 'EDIT_MENU_ITEM';
const UPDATE_MENU_ITEM = 'UPDATE_MENU_ITEM';
const EDIT_MENU_ITEM_SUBMIT = 'EDIT_MENU_ITEM_SUBMIT';
const EDIT_MENU_ITEM_SUCCESS = 'EDIT_MENU_ITEM_SUCCESS';
const UPDATE_STATUS_API = 'UPDATE_STATUS_API';
const UPDATE_STATUS_API_SUCCESS = 'UPDATE_STATUS_API_SUCCESS';
const ADD_MENU_ITEM = 'ADD_MENU_ITEM';
const ADD_ITEM_MENU_SUCCESS = 'ADD_ITEM_MENU_SUCCESS';
const SAVE_MENU_ITEM_FAILURE = 'SAVE_MENU_ITEM_FAILURE';
const REMOVE_ITEM_MENU = 'REMOVE_ITEM_MENU';
const REMOVE_ITEM_MENU_SUCCESS = 'REMOVE_ITEM_MENU_SUCCESS';
const ADD_BANNER = 'ADD_BANNER';
const ADD_BANNER_SUCCESS = 'ADD_BANNER_SUCCESS';
const SAVE_BANNER_FAILURE = 'SAVE_BANNER_FAILURE';
const EDIT_BANNER = 'EDIT_BANNER';
const EDIT_BANNER_SUCCESS = 'EDIT_BANNER_SUCCESS';
const UPDATE_BANNER = 'UPDATE_BANNER';
const UPDATE_BANNER_SUCCESS ='UPDATE_BANNER_SUCCESS';
const DELETE_BANNER = 'DELETE_BANNER';
const DELETE_BANNER_SUCCESS = 'DELETE_BANNER_SUCCESS';
const UPDATE_BANNER_STATUS = 'UPDATE_BANNER_STATUS'
const UPDATE_BANNER_STATUS_SUCCESS = 'UPDATE_BANNER_STATUS_SUCCESS'
const UPDATE_BANNER_STATUS_FAILURE = 'UPDATE_BANNER_STATUS_FAILURE'
const API_FETCH_BANNER = 'API_FETCH_BANNER';
const API_FETCH_BANNER_SUCCESS = 'API_FETCH_BANNER_SUCCESS';
const ADD_CATEGORY = 'ADD_CATEGORY';
const ADD_CATEGORY_SUCCESS = 'ADD_CATEGORY_SUCCESS';
const SAVE_CATEGORY_FAILURE = 'SAVE_CATEGORY_FAILURE';
const ADD_USER = 'ADD_USER';
const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
const SAVE_USER_FAILURE = 'SAVE_USER_FAILURE';
const EDIT_CATEGORY = 'EDIT_CATEGORY';
const EDIT_CATEGORY_SUBMIT = 'EDIT_CATEGORY_SUBMIT';
const EDIT_CATEGORY_SUCCESS = 'EDIT_CATEGORY_SUCCESS';
const DELETE_CATEGORY = 'DELETE_CATEGORY';
const DELETE_CATEGORY_SUCCESS = 'DELETE_CATEGORY_SUCCESS';
const DELETE_USER = 'DELETE_USER';
const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';
const UPDATE_USER = 'UPDATE_USER';
const UPDATE_CATEGORY = 'UPDATE_CATEGORY';
const EDIT_USER = 'EDIT_USER';
const EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS';
const EDIT_USER_SUBMIT = "EDIT_USER_SUBMIT";
const GENERATE_LOGIN_OTP = 'GENERATE_LOGIN_OTP';
const GENERATE_LOGIN_OTP_SUCCESS = 'GENERATE_LOGIN_OTP_SUCCESS';
const VERIFY_CONTACT_NUMBER = 'VERIFY_CONTACT_NUMBER';
const VERIFY_CONTACT_NUMBER_SUCCESS = 'VERIFY_CONTACT_NUMBER_SUCCESS';
const SEND_LOGIN = 'SEND_LOGIN';
const SEND_LOGOUT = 'SEND_LOGOUT';
const SEND_LOGIN_SUCCESS = 'SEND_LOGIN_SUCCESS';
const GET_LOGGED_USER = 'GET_LOGGED_USER';
const SEND_LOGIN_OTP = 'SEND_LOGIN_OTP';
const SEND_LOGIN_OTP_SUCCESS = 'SEND_LOGIN_OTP_SUCCESS';
const LOGIN_ERROR = 'LOGIN_ERROR';
const CLEAR_LOGIN_ERROR = 'CLEAR_LOGIN_ERROR';
const OPEN_GLOBAL_POPUP = 'OPEN_GLOBAL_POPUP';
const CLOSE_GLOBAL_POPUP = 'CLOSE_GLOBAL_POPUP';
const FETCH_USERS = 'FETCH_USERS';
const FETCH_USERS_ERROR = 'FETCH_USERS_ERROR';
const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
const FETCH_CATEGORIES = 'FETCH_CATEGORIES';
const FETCH_CATEGORIES_ERROR = 'FETCH_CATEGORIES_ERROR';
const FETCH_CATEGORIES_SUCCESS = 'FETCH_CATEGORIES_SUCCESS';
const ADD_ITEM_TO_CART = 'ADD_ITEM_TO_CART';
const REMOVE_ITEM_TO_CART = 'REMOVE_ITEM_TO_CART';
const CLEAR_CART = 'CLEAR_CART';
const CLEAR_CART_FOR_TABLE ='CLEAR_CART_FOR_TABLE';
const LOAD_CART_FROM_BILL = 'LOAD_CART_FROM_BILL';
const FETCH_LIVE_ORDERS_BY_TABLEOTP = 'FETCH_LIVE_ORDERS_BY_TABLEOTP';
const FETCH_LIVE_ORDERS = 'FETCH_LIVE_ORDERS';
const FETCH_LIVE_ORDER_SUCCESS = 'FETCH_LIVE_ORDER_SUCCESS';
const FETCH_LIVE_ORDER_FAILURE = 'FETCH_LIVE_ORDER_FAILURE';
const UPDATE_ORDER_STATUS = 'UPDATE_ORDER_STATUS';
const UPDATE_ORDER_STATUS_SUCCESS = "UPDATE_ORDER_STATUS_SUCCESS";
const UPDATE_ORDER_STATUS_FAILURE = "UPDATE_ORDER_STATUS_FAILURE";
const FETCH_CANCEL_ORDER = 'FETCH_CANCEL_ORDER';
const FETCH_CANCEL_ORDER_SUCCESS = 'FETCH_CANCEL_ORDER_SUCCESS';
const FETCH_CANCEL_ORDER_FAILURE = 'FETCH_CANCEL_ORDER_FAILURE';
const FETCH_ORDER_HISTORY = 'FETCH_ORDER_HISTORY';
const FETCH_ORDER_HISTORY_BY_TABLEOTP = 'FETCH_ORDER_HISTORY_BY_TABLEOTP';
const FETCH_ORDER_HISTORY_SUCCESS = 'FETCH_ORDER_HISTORY_SUCCESS';
const FETCH_ORDER_HISTORY_FAILURE = 'FETCH_ORDER_HISTORY_FAILURE';
const ADD_TABLE_NUMBER = "ADD_TABLE_NUMBER";
const ADD_TABLE_NUMBER_SUCCESS = "ADD_TABLE_NUMBER_SUCCESS";
const ADD_TABLE_NUMBER_FAILURE = "ADD_TABLE_NUMBER_FAILURE";
const FETCH_TABLES = "FETCH_TABLES";
const FETCH_TABLES_SUCCESS = "FETCH_TABLES_SUCCESS";
const FETCH_TABLES_FAILURE = "FETCH_TABLES_FAILURE";
const DELETE_TABLE = "DELETE_TABLE";
const DELETE_TABLE_SUCCESS = "DELETE_TABLE_SUCCESS";
const DELETE_TABLE_FAILURE = "DELETE_TABLE_FAILURE";
const EDIT_TABLE = "EDIT_TABLE";
const EDIT_TABLE_SUCCESS = "EDIT_TABLE_SUCCESS";
const EDIT_TABLE_FAILURE = "EDIT_TABLE_FAILURE";
const FETCH_RESTAURANT_DETAIL_REQUEST = "FETCH_RESTAURANT_DETAIL_REQUEST";
const FETCH_RESTAURANT_DETAIL_SUCCESS = "FETCH_RESTAURANT_DETAIL_SUCCESS";
const FETCH_RESTAURANT_DETAIL_FAILURE = "FETCH_RESTAURANT_DETAIL_FAILURE";
const UPDATE_RESTAURANT_PROFILE_REQUEST = "UPDATE_RESTAURANT_PROFILE_REQUEST";
const UPDATE_RESTAURANT_PROFILE_SUCCESS = "UPDATE_RESTAURANT_PROFILE_SUCCESS";
const UPDATE_RESTAURANT_PROFILE_FAILURE = "UPDATE_RESTAURANT_PROFILE_FAILURE";
const FETCH_TAX_REQUEST = "FETCH_TAX_REQUEST";
const FETCH_TAX_SUCCESS = "FETCH_TAX_SUCCESS";
const FETCH_TAX_FAILURE = "FETCH_TAX_FAILURE";
const UPDATE_TAX_REQUEST = "UPDATE_TAX_REQUEST";
const UPDATE_TAX_SUCCESS = "UPDATE_TAX_SUCCESS";
const UPDATE_TAX_FAILURE = "UPDATE_TAX_FAILURE";
const FETCH_TABLES_WITH_OTP = "FETCH_TABLES_WITH_OTP";
const UPDATE_TABLE_STATUS_REQUEST = "UPDATE_TABLE_STATUS_REQUEST";
const UPDATE_TABLE_STATUS_SUCCESS = "UPDATE_TABLE_STATUS_SUCCESS";
const UPDATE_TABLE_STATUS_FAILURE = "UPDATE_TABLE_STATUS_FAILURE";
const PLACE_ORDER_FOR_TABLE = 'PLACE_ORDER_FOR_TABLE';
const PLACE_ORDER_SUCCESS = 'PLACE_ORDER_SUCCESS';
const PLACE_ORDER_FAILURE = 'PLACE_ORDER_FAILURE';
const FETCH_BILL_REQUEST = 'FETCH_BILL_REQUEST';
const FETCH_BILL_SUCCESS = 'FETCH_BILL_SUCCESS';
const SAVE_BILL_REQUEST = "SAVE_BILL_REQUEST";
const SAVE_BILL_SUCCESS = "SAVE_BILL_SUCCESS";
const SAVE_BILL_FAILURE = "SAVE_BILL_FAILURE";
const RESET_SAVED_BILL = "RESET_SAVED_BILL";
const FETCH_BILLS = "FETCH_BILLS";
const FETCH_BILLS_SUCCESS = "FETCH_BILLS_SUCCESS";
const FETCH_BILLS_FAILURE = "FETCH_BILLS_FAILURE";
const FETCH_BILL_ITEM = "FETCH_BILL_ITEM";
const FETCH_BILL_ITEM_SUCCESS = "FETCH_BILL_ITEM_SUCCESS";
const FETCH_BILL_ITEM_FAILURE = "FETCH_BILL_ITEM_FAILURE";
const GET_RESERVATIONS_REQUEST = "GET_RESERVATIONS_REQUEST";
const GET_RESERVATIONS_SUCCESS = "GET_RESERVATIONS_SUCCESS";
const GET_RESERVATIONS_FAILURE = "GET_RESERVATIONS_FAILURE";

const CREATE_RESERVATION_REQUEST = "CREATE_RESERVATION_REQUEST";
const CREATE_RESERVATION_SUCCESS = "CREATE_RESERVATION_SUCCESS";
const SAVE_RESERVATION_FAILURE = "SAVE_RESERVATION_FAILURE";
const UPDATE_RESERVATION_REQUEST = "UPDATE_RESERVATION_REQUEST";
const UPDATE_RESERVATION_SUCCESS = "UPDATE_RESERVATION_SUCCESS";
const EDIT_RESERVATION = "EDIT_RESERVATION";
const FETCH_DASHBOARD = "FETCH_DASHBOARD";
const FETCH_DASHBOARD_SUCCESS = "FETCH_DASHBOARD_SUCCESS";
const CHANGE_PASSWORD = "CHANGE_PASSWORD";
const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
const FETCH_SERVICE_REQUEST = "FETCH_SERVICE_REQUEST";
const FETCH_SERVICE_REQUEST_SUCCESS = "FETCH_SERVICE_REQUEST_SUCCESS";
const UPDATE_SERVICE_REQUEST = "UPDATE_SERVICE_REQUEST";
const UPDATE_SERVICE_REQUEST_SUCCESS = "UPDATE_SERVICE_REQUEST_SUCCESS";
const ADD_NOTE = "ADD_NOTE";
const FETCH_GALLERY_IMAGE ="FETCH_GALLERY_IMAGE";
const FETCH_GALLERY_IMAGE_SUCCESS ="FETCH_GALLERY_IMAGE_SUCCESS";

const FETCH_ADDON_GROUPS = "FETCH_ADDON_GROUPS";
const SET_ADDON_GROUPS = "SET_ADDON_GROUPS";
const SAVE_ADDON_GROUP = "SAVE_ADDON_GROUP";
const SAVE_ADDON_GROUP_SUCCESS = "SAVE_ADDON_GROUP_SUCCESS";
const SAVE_ADDON_GROUP_FAILURE = "SAVE_ADDON_GROUP_FAILURE";
const DELETE_ADDON_GROUP = "DELETE_ADDON_GROUP";
const DELETE_ADDON_GROUP_SUCCESS = "DELETE_ADDON_GROUP_SUCCESS";
const DELETE_OPERATION_FAILURE = "DELETE_OPERATION_FAILURE";
const EDIT_ADDON_GROUP = "EDIT_ADDON_GROUP";

const FETCH_CATEGORY_ADDON_MAPPINGS = "FETCH_CATEGORY_ADDON_MAPPINGS";
const SET_CATEGORY_ADDON_MAPPINGS = "SET_CATEGORY_ADDON_MAPPINGS";
const SAVE_CATEGORY_ADDON_MAPPINGS = "SAVE_CATEGORY_ADDON_MAPPINGS";
const CLEAR_CATEGORY_ADDON_MAPPINGS = "CLEAR_CATEGORY_ADDON_MAPPINGS";

const FETCH_MENU_ITEM_ADDON_MAPPINGS = "FETCH_MENU_ITEM_ADDON_MAPPINGS";
const SET_MENU_ITEM_ADDON_MAPPINGS = "SET_MENU_ITEM_ADDON_MAPPINGS";
const SAVE_MENU_ITEM_ADDON_OVERRIDE = "SAVE_MENU_ITEM_ADDON_OVERRIDE";
const CLEAR_MENU_ITEM_ADDON_MAPPINGS = "CLEAR_MENU_ITEM_ADDON_MAPPINGS";


export {
    FETCH_MENU_ITEM_ADDON_MAPPINGS,
    SET_MENU_ITEM_ADDON_MAPPINGS,
    SAVE_MENU_ITEM_ADDON_OVERRIDE,
    CLEAR_MENU_ITEM_ADDON_MAPPINGS,
    FETCH_CATEGORY_ADDON_MAPPINGS,
    SET_CATEGORY_ADDON_MAPPINGS,
    SAVE_CATEGORY_ADDON_MAPPINGS,
    CLEAR_CATEGORY_ADDON_MAPPINGS,
    FETCH_ADDON_GROUPS,
    SET_ADDON_GROUPS,
    SAVE_ADDON_GROUP,
    SAVE_ADDON_GROUP_SUCCESS,
    SAVE_ADDON_GROUP_FAILURE,
    DELETE_ADDON_GROUP,
    DELETE_ADDON_GROUP_SUCCESS,
    DELETE_OPERATION_FAILURE,
    EDIT_ADDON_GROUP,
    ADD_NOTE,
    FETCH_GALLERY_IMAGE,
    FETCH_GALLERY_IMAGE_SUCCESS,
    RESET_USER_DETAILS,
    VERIFY_CONTACT_NUMBER,
    VERIFY_CONTACT_NUMBER_SUCCESS,
    FETCH_SERVICE_REQUEST,
    FETCH_SERVICE_REQUEST_SUCCESS,
    UPDATE_SERVICE_REQUEST,
    UPDATE_SERVICE_REQUEST_SUCCESS,
    CHANGE_PASSWORD,
    CHANGE_PASSWORD_SUCCESS,
    FETCH_DASHBOARD,
    FETCH_DASHBOARD_SUCCESS,
    EDIT_RESERVATION,
    GET_RESERVATIONS_REQUEST,
    GET_RESERVATIONS_SUCCESS,
    GET_RESERVATIONS_FAILURE,
    CREATE_RESERVATION_REQUEST,
    CREATE_RESERVATION_SUCCESS,
    SAVE_RESERVATION_FAILURE,
    UPDATE_RESERVATION_REQUEST,
    UPDATE_RESERVATION_SUCCESS,
    CLEAR_CART,
    LOAD_CART_FROM_BILL,
    FETCH_BILL_ITEM,
    FETCH_BILL_ITEM_SUCCESS,
    FETCH_BILL_ITEM_FAILURE,
    FETCH_BILLS,
    FETCH_BILLS_SUCCESS,
    FETCH_BILLS_FAILURE,
    SAVE_BILL_REQUEST,
    SAVE_BILL_SUCCESS,
    SAVE_BILL_FAILURE,
    RESET_SAVED_BILL,
    FETCH_BILL_REQUEST,
    FETCH_BILL_SUCCESS,
    PLACE_ORDER_FOR_TABLE,
    PLACE_ORDER_SUCCESS,
    PLACE_ORDER_FAILURE,
    FETCH_LIVE_ORDERS_BY_TABLEOTP,
    FETCH_TABLES_WITH_OTP,
    UPDATE_TABLE_STATUS_REQUEST,
    UPDATE_TABLE_STATUS_SUCCESS,
    UPDATE_TABLE_STATUS_FAILURE,
    FETCH_TAX_REQUEST,
    FETCH_TAX_SUCCESS,
    FETCH_TAX_FAILURE,
    UPDATE_TAX_REQUEST,
    UPDATE_TAX_SUCCESS,
    UPDATE_TAX_FAILURE,
    FETCH_RESTAURANT_DETAIL_REQUEST,
    FETCH_RESTAURANT_DETAIL_SUCCESS,
    FETCH_RESTAURANT_DETAIL_FAILURE,
    UPDATE_RESTAURANT_PROFILE_REQUEST,
    UPDATE_RESTAURANT_PROFILE_SUCCESS,
    UPDATE_RESTAURANT_PROFILE_FAILURE,
    EDIT_TABLE,
    EDIT_TABLE_SUCCESS,
    EDIT_TABLE_FAILURE,
    DELETE_TABLE,
    DELETE_TABLE_SUCCESS,
    DELETE_TABLE_FAILURE,
    FETCH_TABLES,
    FETCH_TABLES_SUCCESS,
    FETCH_TABLES_FAILURE,
    ADD_TABLE_NUMBER,
    ADD_TABLE_NUMBER_SUCCESS,
    ADD_TABLE_NUMBER_FAILURE,
    FETCH_LIVE_ORDERS,
    FETCH_LIVE_ORDER_SUCCESS,
    FETCH_LIVE_ORDER_FAILURE,
    FETCH_CANCEL_ORDER,
    FETCH_CANCEL_ORDER_SUCCESS,
    FETCH_CANCEL_ORDER_FAILURE,
    FETCH_ORDER_HISTORY,
    FETCH_ORDER_HISTORY_BY_TABLEOTP,
    FETCH_ORDER_HISTORY_SUCCESS,
    FETCH_ORDER_HISTORY_FAILURE,
    UPDATE_ORDER_STATUS,
    UPDATE_ORDER_STATUS_SUCCESS,
    UPDATE_ORDER_STATUS_FAILURE,
    ADD_ITEM_TO_CART,
    REMOVE_ITEM_TO_CART,
    CLEAR_CART_FOR_TABLE,
    API_FETCH_MENU_SUCCESS,
    API_FETCH_MENU,
    API_FETCH_USER_SUCCESS,
    API_FETCH_USER,
    ADD_MENU_ITEM,
    ADD_ITEM_MENU_SUCCESS,
    SAVE_MENU_ITEM_FAILURE,
    API_FETCH_MENU_ITEM,
    API_FETCH_MENU_iTEM_SUCCESS,
    API_FETCH_MENU_iTEM_ERROR,
    REMOVE_ITEM_MENU,
    REMOVE_ITEM_MENU_SUCCESS,
    EDIT_MENU_ITEM,
    UPDATE_MENU_ITEM,
    EDIT_MENU_ITEM_SUBMIT,
    EDIT_MENU_ITEM_SUCCESS,
    UPDATE_ITEM_STATUS_MENU,
    UPDATE_STATUS_API,
    UPDATE_STATUS_API_SUCCESS,
    ADD_CATEGORY,
    ADD_CATEGORY_SUCCESS,
    SAVE_CATEGORY_FAILURE,
    EDIT_CATEGORY,
    EDIT_CATEGORY_SUBMIT,
    EDIT_CATEGORY_SUCCESS,
    DELETE_CATEGORY,
    DELETE_CATEGORY_SUCCESS,
    ADD_USER,
    ADD_USER_SUCCESS,
    SAVE_USER_FAILURE,
    UPDATE_USER,
    UPDATE_CATEGORY,
    DELETE_USER,
    DELETE_USER_SUCCESS,
    EDIT_USER,
    EDIT_USER_SUBMIT,
    EDIT_USER_SUCCESS,
    GENERATE_LOGIN_OTP,
    SEND_LOGIN,
    SEND_LOGOUT,
    SEND_LOGIN_SUCCESS,
    GET_LOGGED_USER,
    SEND_LOGIN_OTP,
    SEND_LOGIN_OTP_SUCCESS,
    UPDATE_ITEM_MENU,
    UPDATE_ITEM_MENU_SUCCESS,
    GENERATE_LOGIN_OTP_SUCCESS,
    RESET_PASSWORD,
    RESET_PASSWORD_SUCCESS,
    FETCH_USERS,
    FETCH_USERS_ERROR,
    FETCH_USERS_SUCCESS,
    FETCH_CATEGORIES,
    FETCH_CATEGORIES_ERROR,
    FETCH_CATEGORIES_SUCCESS,
    LOGIN_ERROR,
    CLEAR_LOGIN_ERROR,
    OPEN_GLOBAL_POPUP,
    CLOSE_GLOBAL_POPUP,
    ADD_BANNER,
    ADD_BANNER_SUCCESS,
    SAVE_BANNER_FAILURE,
    UPDATE_BANNER,
    UPDATE_BANNER_SUCCESS,
    EDIT_BANNER,
    EDIT_BANNER_SUCCESS,
    DELETE_BANNER,
    DELETE_BANNER_SUCCESS,
    API_FETCH_BANNER,
    API_FETCH_BANNER_SUCCESS,
    UPDATE_BANNER_STATUS,
    UPDATE_BANNER_STATUS_SUCCESS,
    UPDATE_BANNER_STATUS_FAILURE
}
